<template><option :value="value"><slot></slot></option></template>
<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({ name: 'BFormSelectOption', props: { value: { default: undefined } } })
</script>
